<template>
  <div class="interactives-textarea-input">
    <label v-if="inputData.label" :for="inputData.name">{{ inputData.label }}</label>
    <textarea
      :name="inputData.name"
      :placeholder="inputData.placeholder"
      v-model="value"
    />
  </div>
</template>

<script>

export default {
  name: 'interactives-textarea-input',
  props: ['inputData'],
  data () {
    return {
      value: null
    }
  },
  watch: {
    value: function (newValue) { this.inputData.value = newValue }
  }
}
</script>

<style>
.interactives-textarea-input {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-input/src/components/TextareaInput.vue